import { Link } from "react-router-dom";
import { PublicFooter } from "@/components/common/PublicFooter";
import { PublicNav } from "@/components/common/PublicNav";

export function NotFound() {
  return (
    <div className="sa-page" style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <PublicNav />
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "120px 40px",
          textAlign: "center",
        }}
      >
        <div className="sa-label" style={{ marginBottom: 18 }}>
          404
        </div>
        <h1
          style={{
            fontFamily: "var(--sa-serif)",
            fontWeight: 400,
            fontSize: 44,
            margin: "0 0 16px",
            letterSpacing: "-0.015em",
            fontStyle: "italic",
          }}
        >
          This page was not found.
        </h1>
        <Link
          to="/"
          style={{
            color: "var(--sa-accent)",
            textDecoration: "underline",
            textUnderlineOffset: 3,
            fontFamily: "var(--sa-sans)",
            fontSize: 14,
          }}
        >
          Return to the beginning
        </Link>
      </div>
      <PublicFooter />
    </div>
  );
}
